import React from 'react'

const BookmarkIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.0625 2.32806C5.74755 2.32806 5.44551 2.45071 5.22281 2.669C5.00012 2.8873 4.875 3.18337 4.875 3.49209V20.2332L12 16.7411L19.125 20.2332V3.49209C19.125 3.18337 18.9998 2.8873 18.7772 2.669C18.5545 2.45071 18.2524 2.32806 17.9375 2.32806H6.0625ZM3.54343 1.02281C4.21153 0.367915 5.11767 0 6.0625 0H17.9375C18.8823 0 19.7885 0.367915 20.4565 1.02281C21.1246 1.67771 21.5 2.56593 21.5 3.49209V24L12 19.3439L2.5 24V3.49209C2.5 2.56593 2.87533 1.67771 3.54343 1.02281Z" />
    </svg>
  )
}

export default BookmarkIcon
